<script lang="ts">
  interface Props {
    children?: import('svelte').Snippet;
  }

  let { children }: Props = $props();
</script>

<div class="comp-grid-view">
  {@render children?.()}
</div>

<style>
  .comp-grid-view {
    width: 100%;
    min-width: 872px;
    max-width: 1400px;
    height: 100%;
    margin: 0 auto;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 24px;
  }
</style>
